module.exports = __webpack_public_path__ + "img/training_DrThummGmbH_RZ_RGB.7c4a26fc.png";